/**
 * Featured Variants Section JavaScript
 * Handles variant slider for both desktop and mobile
 */

class FeaturedVariantsSection {
  constructor(element) {
    this.element = element;
    this.slider = this.element.querySelector('[data-slider]');
    this.prevButton = this.element.querySelector('.featured-variants__slider-button--prev');
    this.nextButton = this.element.querySelector('.featured-variants__slider-button--next');

    if (this.slider && this.prevButton && this.nextButton) {
      this.init();
    }
  }

  init() {
    this.products = this.slider.querySelectorAll('.featured-variants__product');
    if (this.products.length === 0) return;

    this.currentIndex = 0;

    this.prevButton.addEventListener('click', () => this.slidePrev());
    this.nextButton.addEventListener('click', () => this.slideNext());

    this.resizeHandler = () => this.updateSlider();
    window.addEventListener('resize', this.resizeHandler);

    this.updateSlider();
    this.initDragScroll();
  }

  getSlideWidth() {
    if (this.products.length === 0) return 0;
    const gap = parseFloat(getComputedStyle(this.slider).gap) || 0;
    return this.products[0].offsetWidth + gap;
  }

  updateSlider() {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    const scrollPosition = this.currentIndex * this.getSlideWidth();

    this.slider.scrollTo({
      left: scrollPosition,
      behavior: 'smooth'
    });

    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = scrollPosition >= maxScroll - 10;
  }

  slideNext() {
    const slideWidth = this.getSlideWidth();
    const visibleItems = Math.floor(this.slider.clientWidth / slideWidth);
    const maxIndex = this.products.length - visibleItems;

    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
      this.updateSlider();
    }
  }

  slidePrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
    }
  }

  initDragScroll() {
    let isDown = false;
    let startX;
    let scrollLeft;

    this.slider.addEventListener('mousedown', (e) => {
      isDown = true;
      this.slider.style.cursor = 'grabbing';
      startX = e.pageX - this.slider.offsetLeft;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('mouseleave', () => {
      isDown = false;
      this.slider.style.cursor = 'grab';
    });

    this.slider.addEventListener('mouseup', () => {
      isDown = false;
      this.slider.style.cursor = 'grab';
    });

    this.slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - startX) * 2;
      this.slider.scrollLeft = scrollLeft - walk;
    });
  }

  destroy() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
}

// Initialize all featured variants sections
function initFeaturedVariantsSections() {
  const sections = document.querySelectorAll('.featured-variants');
  sections.forEach(section => {
    new FeaturedVariantsSection(section);
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedVariantsSections);
} else {
  initFeaturedVariantsSections();
}

// Re-initialize when Shopify section is updated in the theme editor
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('featured-variants') ||
        event.target.querySelector('.featured-variants')) {
      initFeaturedVariantsSections();
    }
  });
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = FeaturedVariantsSection;
}
